export const CREATE_USER_GROUP_REQUEST = "CREATE_USER_GROUP_REQUEST"
export const CREATE_USER_GROUP_SUCCESS = "CREATE_USER_GROUP_SUCCESS"
export const CREATE_USER_GROUP_ERROR = "CREATE_USER_GROUP_ERROR"

export const DELETE_USER_GROUP_REQUEST = "DELETE_USER_GROUP_REQUEST"
export const DELETE_USER_GROUP_SUCCESS = "DELETE_USER_GROUP_SUCCESS"
export const DELETE_USER_GROUP_ERROR = "DELETE_USER_GROUP_ERROR"